/* eslint-disable @typescript-eslint/no-var-requires */
const en = require('./source/en.json');
const ja = require('./source/ja.json');
export const resources = { en, ja };
